module.exports = __webpack_public_path__ + "static/water_glacier3-6e696cf53aacf300b3f6e3e40fb3eb90.jpg";